interface ImageDimension {
    width: number;
    height: number;
}

export const getImageDimension = (
    aspectRatio: number,
    maxWidthHeight: number,
    isPortrait: boolean,
): ImageDimension => {
    if (isPortrait) {
        return {
            width: Math.floor(maxWidthHeight / aspectRatio),
            height: maxWidthHeight,
        };
    }
    return {
        width: maxWidthHeight,
        height: Math.floor(maxWidthHeight / aspectRatio),
    };
};
